import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'syaratJabatan'
const baseUrl = process.env.REACT_APP_SERVICE_ASSESMENT_URL
const appCode = process.env.REACT_APP_SERVICE_ASSESMENT_APPCODE
const outputType = 'json'

export const syaratJabatanCreate = 'Master/PositionRequisite/create/'
export const syaratJabatanList = '/Master/PositionRequisite/list/'
export const syaratJabatanDetail = 'Master/PositionRequisite/detail/'
export const syaratJabatanUpdate = 'Master/PositionRequisite/update/'
export const syaratJabatanInactive = 'Master/PositionRequisite/inactive/'
export const syaratJabatanActive = 'Master/PositionRequisite/active/'
export const infoJabatan = 'Master/PositionRequisite/position_info/'
export const positionTask = 'Master/PositionRequisite/positionTask/'
export const positionTaskUpdate = 'Master/PositionRequisite/update_task/'
export const responsibilityUpdate = 'Master/PositionRequisite/update_responsibility/'
export const authorityUpdate = 'Master/PositionRequisite/update_authority/'
export const responsibility = 'Master/PositionRequisite/responsibility/'
export const Authority = 'Master/PositionRequisite/detail_authority/'
export const detailPossesionRequisite = 'Master/PositionRequisite/detailPossesionRequisite/'
export const positionRequisiteUpdate = 'Master/PositionRequisite/positionRequisiteUpdate/'
export const detailExperience = 'Master/PositionRequisite/detailExperience/'
export const detailTraining = 'Master/PositionRequisite/detailTraining/'
export const detailInterest = 'Master/PositionRequisite/detailInterest/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}